import { ActionReducerMap } from '@ngrx/store';
import * as fromCop from './cop.reducer';
import * as fromRsd from '../rsd';
import * as fromLists from '../lists';
import * as fromImpactedAssets from '../impacted-assets';
import * as fromCameras from '../cameras';

export * from './models';
export * from './cop.actions';
export * from './cop.selectors';
export * from './cop.reducer';
export * from './cop.effects';
export * from '../lsd';

export const reducers: ActionReducerMap<fromCop.CopModuleState> = {
  cop: fromCop.reducer,
  rsd: fromRsd.reducer,
  lists: fromLists.reducer,
  impactedAssets: fromImpactedAssets.reducer,
  cameras: fromCameras.reducer
};
